var map = {
	"./SHS-ASURION/faq-topics.json": 3407,
	"./SHS-SPRINT/faq-topics.json": 3408,
	"./SHS-WEB/faq-topics.json": 3409,
	"./TCH-WEB/faq-topics.json": 3410
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3406;


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/faqpage/resources/data ^\.\/.*\/faq\-topics\.json$
// module id = 3406
// module chunks = 0